import { render, staticRenderFns } from "./articleManage.vue?vue&type=template&id=3dcb57e0&scoped=true"
import script from "./articleManage.vue?vue&type=script&lang=js"
export * from "./articleManage.vue?vue&type=script&lang=js"
import style0 from "./articleManage.vue?vue&type=style&index=0&id=3dcb57e0&prod&lang=scss&scoped=true"
import style1 from "./articleManage.vue?vue&type=style&index=1&id=3dcb57e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcb57e0",
  null
  
)

export default component.exports